import React from "react";
import "./VendorHero.css";

export default function VendorHero() {
  return (
    <section className="vendor-hero" aria-labelledby="vendor-hero-title">
      <div className="vh-wrap">
        <p className="vh-eyebrow">Sell on Maplee</p>

        <h1 id="vendor-hero-title" className="vh-title">
          Reach Thousands of independent customers across Canada
        </h1>

        <p className="vh-sub">
          Sign up to start selling in Maplee’s online marketplace. No set‑up fees. No commitments.
        </p>

        <form 
          className="vh-form" 
          onSubmit={(e) => {
            e.preventDefault();
            window.location.href = "https://www.maplee.ca/auth/sign-up?redirect=/vendor/apply";
          }}
        >
          <button type="submit">Start Selling</button>
        </form>

        <p className="vh-note">
          Already on Maplee? <a href="https://www.maplee.ca/auth/login">Sign In</a>
        </p>
      </div>
    </section>
  );
}
